<template>
  <!-- 面包屑组件 -->
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span v-if="item.redirect === 'noRedirect' || index == levelList.length - 1" class="no-redirect">{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
    // 监听路由标题更新事件
    this.$root.$on('route-title-updated', this.getBreadcrumb)
  },
  beforeDestroy() {
    this.$root.$off('route-title-updated', this.getBreadcrumb)
  },
  methods: {
    getBreadcrumb () {
      // only show routes with meta.title
      let matched = []
      const router = this.$route
      
      // 直接使用 router.matched，不依赖 store
      matched = router.matched.filter( item => item.meta && item.meta.title )
      
      // 处理新闻详情页面的动态面包屑
      if (router.meta && router.meta.dynamicBreadcrumb && router.params.category) {
        matched = this.buildNewsBreadcrumb(matched, router)
      }
      
      // 判断是否为首页
      if (!this.isDashboard( matched[ 0 ] )) {
        matched = [{ path: "/home", meta: { title: "首页" } }].concat( matched )
      }
      this.levelList = matched.filter( item => item.meta && item.meta.title && item.meta.breadcrumb !== false )
    },
    buildNewsBreadcrumb(matched, router) {
      // 为新闻详情页面构建特殊的面包屑层级
      const categoryMap = router.meta.categoryMap || {}
      const category = router.params.category
      const categoryTitle = categoryMap[category]
      
      if (categoryTitle) {
        // 找到新闻资讯的根路由
        const newsRootIndex = matched.findIndex(item => 
          item.path === '/news' || item.path.startsWith('/news')
        )
        
        if (newsRootIndex !== -1) {
          // 在新闻资讯和详情页之间插入分类层级
          const categoryRoute = {
            path: `/news/${category}`,
            meta: { 
              title: categoryTitle,
              breadcrumb: true 
            }
          }
          
          // 重新构建matched数组，插入分类层级
          const newMatched = [
            ...matched.slice(0, newsRootIndex + 1), // 新闻资讯及之前的路由
            categoryRoute, // 分类路由
            ...matched.slice(newsRootIndex + 1) // 详情页路由
          ]
          
          return newMatched
        }
      }
      
      return matched
    },
    isDashboard ( route ) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim() === 'Index'
    },
    handleLink ( item ) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push( redirect )
        return
      }
      this.$router.push( path )
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
